import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {FeedbackCategory} from './feedback-category.model';
import * as FeedbackCategoryActions from './feedback-category.actions';

export const feedbackCategoriesFeatureKey = 'feedbackCategories';

export interface State extends EntityState<FeedbackCategory> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FeedbackCategory> = createEntityAdapter<FeedbackCategory>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FeedbackCategoryActions.addFeedbackCategory,
    (state, action) => adapter.addOne(action.feedbackCategory, state)
  ),
  on(FeedbackCategoryActions.upsertFeedbackCategory,
    (state, action) => adapter.upsertOne(action.feedbackCategory, state)
  ),
  on(FeedbackCategoryActions.addFeedbackCategorys,
    (state, action) => adapter.addMany(action.feedbackCategorys, state)
  ),
  on(FeedbackCategoryActions.upsertFeedbackCategorys,
    (state, action) => adapter.upsertMany(action.feedbackCategorys, state)
  ),
  on(FeedbackCategoryActions.updateFeedbackCategory,
    (state, action) => adapter.updateOne(action.feedbackCategory, state)
  ),
  on(FeedbackCategoryActions.updateFeedbackCategorys,
    (state, action) => adapter.updateMany(action.feedbackCategorys, state)
  ),
  on(FeedbackCategoryActions.deleteFeedbackCategory,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FeedbackCategoryActions.deleteFeedbackCategorys,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FeedbackCategoryActions.loadFeedbackCategorys,
    (state, action) => adapter.setAll(action.feedbackCategorys, state)
  ),
  on(FeedbackCategoryActions.clearFeedbackCategorys,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
